import { useQuery } from '@tanstack/react-query';
import { getPlatformUsers } from 'api/platformUsers';
import { platformUsersKeys } from 'api/queryKeys';
import { Flex, Line, Spinner } from 'components';
import { BackButton } from 'components/BackButton';
import { H1, H2 } from 'components/Typography/Typography';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper } from '../CompanyAdministrationView/CompanyAdministrationView.styled';
import { PlatformUsersTable } from './components/PlatformUsersTable';

export const PlatformUsersView = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useQuery({
    queryKey: platformUsersKeys.all(),
    queryFn: () => getPlatformUsers(),
    refetchOnMount: 'always'
  });

  const users = data?.data ?? [];

  const { withCompany, withoutCompany } = useMemo(
    () => ({
      withCompany: users.filter((u) => u.company_id),
      withoutCompany: users.filter((u) => !u.company_id)
    }),
    [users]
  );

  return (
    <Wrapper mb={94} flexDirection="column">
      <Flex width="100%" alignItems="center">
        <BackButton />
        <H1 m={2} variant={['h3', 'h2']} textTransform="uppercase">
          {t('platform.title')} | {t('platform.users.title')}
        </H1>
      </Flex>
      <Line />

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <H2 mt={3} variant="h3">
            {t('platformUsers.withCompany')}
          </H2>
          <PlatformUsersTable users={withCompany} />

          <H2 mt={4} variant="h3">
            {t('platformUsers.withoutCompany')}
          </H2>
          <PlatformUsersTable users={withoutCompany} showCompany={false} />
        </>
      )}
    </Wrapper>
  );
};
